export default __webpack_public_path__ + "static/media/124.d827b960.png";